<template>
  <div class="categories h100-full bg-white flex flex-column">
    <div class="shop-cart text-right pad5-t pad5-r" @click="routerClick('/cart', 'cart')">
      <span class="white f10 radius30" v-if="countCart">{{ countCart }}</span>
    </div>
    <!-- search -->
    <div class="pad12-t pad12-lr" @click="routerClick('mob/goods/searchPage.do', 'sc')">
      <Search />
    </div>
    <!-- 一级分类 -->
    <div
      class="pad12-t pad12-l pad5-b mar10-b guide flex items-center justify-between relative z-index1"
    >
      <div v-if="guideAllShow" class="guide-mask z-index2"></div>
      <div class="flex-auto guide-list" id="topNav">
        <ul class="ul-cls inline-block" id="topNavUl">
          <li
            class="text-center inline-block"
            :class="{ active: guideActive === item.id }"
            v-for="(item, index) in guideList"
            :key="item.id"
            @click="chooseGuide(item.id, index, $event)"
          >
            <!-- bor-primary   bg-primary white-->
            <div class="text-center">
              <img class="radius50" :src="`${item.icon}?imageView2/1/w/80/h/80`" />
            </div>
            <span class="f12 mar5-t radius30 gray3">{{ item.classificationName }}</span>
          </li>
        </ul>
      </div>
      <div class="guide-more flex items-center justify-center" @click="guideAllToggle">
        <span class="f10 fb mar5-b">展开</span>
        <img src="./images/guide-more.png" />
      </div>
      <div
        class="absolute bg-white text-center overflow all z-index3"
        :style="{ maxHeight: guideAllHeight }"
      >
        <ul class="ul-cls flex flex-wrap pad12-lr pad12-t">
          <li
            class="flex flex-column items-center justify-center"
            :class="{ active: guideActive === item.id }"
            v-for="(item, index) in guideList"
            :key="item.id"
            @click="chooseGuide(item.id, index, 'all')"
          >
            <img class="radius50" :src="`${item.icon}?imageView2/1/w/80/h/80`" />
            <span class="f12 gray3 mar5-t radius30">{{ item.classificationName }}</span>
          </li>
        </ul>
        <div class="all-close flex items-center justify-center" @click="guideAllToggle">
          <span class="f12">点击收起</span>
          <img src="./images/arrow.png" />
        </div>
      </div>
    </div>
    <div class="flex flex-auto">
      <div class="flex-shrink class overflow-auto">
        <ul class="bg-white">
          <li
            class="f12 relative item flex items-center justify-center"
            v-for="(item, index) in classList"
            :key="item.id"
            :class="{
              active: classActive === item.id,
              radius: classList[index + 1] && classActive === classList[index + 1].id
            }"
            @click="chooseClass(item)"
          >
            <span
              class="f16 white radius5 class-subName flex items-center justify-center"
              v-if="item.subName"
              >{{ item.subName }}</span
            >
            {{ item.classificationName }}
          </li>
        </ul>
      </div>
      <div class="flex flex-column flex-auto bg-fd">
        <!-- <img src="./images/good-adv.png" class="mar10 radius5 right-ad" /> -->
        <van-swipe :autoplay="3000" lazy-render class="mar10" v-if="adList.length">
          <van-swipe-item
            v-for="item in adList"
            :key="item.img"
            @click="routerClick(item.url, 'adv')"
          >
            <van-image lazy-load class="right-ad" :src="`${item.img}?imageView2/1/w/550/h/180`" />
          </van-swipe-item>
        </van-swipe>
        <!-- <div class="flex gray6 mar20-b mar10-lr relative class2">
          <div class="flex-auto">
            <ul class="flex nowrap overflow">
              <li class="flex radius5 items-center pad10-lr mar5-r item">
                <img src="./images/hot.png" class="hot" />
                <span>人气推荐</span>
              </li>
              <li class="radius5 pad10-lr mar5-r item active">特惠专区</li>
              <li class="radius5 pad10-lr mar5-r item">教槽料</li>
              <li class="radius5 pad10-lr mar5-r item">乳猪料</li>
              <li
                class="radius5 pad10-lr mar5-r item"
                v-for="(item, index) in class2AllList"
                :key="index"
                :class="{
                  active: class2Active === item.id,
                }"
                :id="item.scrollId"
                @click="chooseCategoriesLevel2(index)"
              >
                {{ item.name }}
              </li>
            </ul>
          </div>
          <div class="flex flex-shrink items-center bg-white pad10-l" @click="class2AllToggle">
            <img
              src="./images/arrow.png"
              class="right-arrow mar5-r"
              :class="{ active: class2AllActive }"
            />
          </div>
          <div class="absolute bg-white text-center overflow all z-index3" :style="{ maxHeight: class2AllHeight }">
            <ul class="flex flex-wrap justify-between pad10-b">
              <li
                class="radius5 mar10-b item"
                v-for="(item, index) in class2AllList"
                :key="index"
                :class="{
                  active: class2Active === item.id,
                }"
                @click="chooseCategoriesLevel2(index)"
              >
                {{ item.name }}
              </li>
              <li class="radius5 mar10-b item active">特惠专区</li>
              <li class="radius5 mar10-b item">教槽料</li>
              <li class="radius5 mar10-b item">乳猪料</li>
              <li class="radius5 mar10-b item">乳猪料</li>
              <li class="radius5 mar10-b item">乳猪料</li>
              <div class="item h0"></div>
            </ul>
          </div>
        </div> -->
        <div class="h0 flex-auto goods">
          <div class="h100-full overflow-auto pad20-b" id="goodListWrap">
            <van-loading size="20px" class="text-center pad10" v-if="goodLoading"
              >加载中...</van-loading
            >
            <van-list
              id="goodList"
              v-else
              :loading="allGoodLoaing"
              :finished="allGoodFinished"
              :offset="10"
              finished-text="没有更多了"
              @load="onLoad"
            >
              <div
                class="flex pad10-tb mar10-lr border-b item"
                v-for="item in goodsList"
                :key="item.goodsId"
                @click="routerClick(`/goodDetails/${item.goodsId}`)"
              >
                <div
                  class="overflow flex items-center justify-center relative flex-shrink radius5 mar10-r img"
                >
                  <div
                    v-if="item.subscriptList && item.subscriptList.length"
                    class="absolute z-index2 goods-badge"
                  >
                    <img
                      v-if="item.subscriptList[0].code == 'ZL_YH'"
                      class="w90 h30"
                      src="https://nfs.nxin.com/cms_image_b7007a5b-168c-4e50-9721-eec66d6cf7e5.png"
                    />
                    <img
                      v-else-if="item.subscriptList[0].code == 'BP'"
                      class="w90 h30"
                      src="https://nfs.nxin.com/cms_image_4a4b45d9-58b1-49b0-89ee-7a03f91b5225.png"
                    />
                    <img
                      v-else-if="item.subscriptList[0].code == 'YX'"
                      class="w90 h30"
                      src="https://nfs.nxin.com/cms_image_b6ee03a9-cb9e-4023-8a72-63c85b4aff5a.png"
                    />
                  </div>
                  <van-image
                    v-if="item.goodsImg"
                    lazy-load
                    :src="`${item.goodsImg}?imageView2/1/w/150/h/150`"
                  />
                  <img v-else src="../../assets/images/good/good-none.png" class="radius5" />
                </div>
                <div class="flex flex-auto flex-column justify-between">
                  <div class="gray3 f13 ellipsis_two lin16 fb">
                    <img
                      class="h15 mar5-r"
                      v-if="item.isShowFarmersDayLabel"
                      src="https://nfs.nxin.com/cms_image_546d8af9-8df0-47d0-8fe7-df4e51e209e7.png"
                    />
                    {{ item.goodsNameStr }}
                  </div>
                  <div class="flex items-start f10 tags">
                    <div
                      class="mar5-r mar3-b radius30 pad5-lr lh-1 tag"
                      v-for="(val, index) in item.tag"
                      :key="index"
                    >
                      {{ val }}
                    </div>
                  </div>
                  <div v-if="item.goodsPriceMemberLevel" class="flex">
                    <div
                      class="f10 items-center flex price-member"
                      :class="{
                        vip2: item.goodsPriceMemberLevel == '2',
                        vip3: item.goodsPriceMemberLevel == '3',
                        vip4: item.goodsPriceMemberLevel == '4',
                        vip5: item.goodsPriceMemberLevel == '5'
                      }"
                    >
                      <img
                        v-if="item.goodsPriceMemberLevel == '1'"
                        src="https://nfs.nxin.com/cms_image_b240a2d2-16f7-4373-bbf2-ad5c174955a5.png"
                        class="w20"
                      />
                      <img
                        v-else-if="item.goodsPriceMemberLevel == '2'"
                        src="https://nfs.nxin.com/cms_image_e64adf1d-9f33-4fb8-a76f-411d131b0a15.png"
                        class="w20"
                      />
                      <img
                        v-else-if="item.goodsPriceMemberLevel == '3'"
                        src="https://nfs.nxin.com/cms_image_288fce89-a676-4fb3-abe7-edf328256bcb.png"
                        class="w20"
                      />
                      <img
                        v-else-if="item.goodsPriceMemberLevel == '4'"
                        src="https://nfs.nxin.com/cms_image_cd497405-898c-43c0-8aa2-c40f5e74d9ce.png"
                        class="w20"
                      />
                      <img
                        v-else-if="item.goodsPriceMemberLevel == '5'"
                        src="https://nfs.nxin.com/cms_image_75a61308-16b4-4c17-bd51-f1840f4bb869.png"
                        class="w20"
                      />
                      <div>￥{{ item.vipMoneyStr }}</div>
                    </div>
                  </div>
                  <div class="flex items-end">
                    <div class="w0 flex-auto">
                      <div class="flex c-d1d1d1 items-end">
                        <template v-if="item.sellFactPrice">
                          <span class="f11 red">￥</span>
                          <span class="f18 red relative price">{{ item.price[0] }}</span>
                          <span class="f11 red" v-if="item.price[1]">.{{ item.price[1] }}</span>
                          <span class="f10 gray9 mar5-l mar10-r self-end">{{ item.spec }}</span>
                        </template>
                        <!-- <span class="line-through f10 gray9">￥120.00</span> -->
                        <span v-else class="red">点击询价</span>
                      </div>
                    </div>
                    <div class="pad20-l" v-if="item.sellFactPrice" @click.stop="addCart(item)">
                      <img src="./images/shop.png" class="w20" />
                    </div>
                  </div>
                </div>
              </div>
            </van-list>
          </div>
        </div>
      </div>
    </div>
    <!--加购物车选择规则弹框-->
    <!--eslint-disable-next-line-->
    <van-popup v-model:show="addCartShow" :safe-area-inset-bottom="true" closeable round>
      <div class="addCart_pop">
        <div class="addCart_pop_main flex flex-column">
          <div class="clear addCart_good_info flex">
            <!-- <img class="float-left" :src="detail.imgUrl1" alt=""> -->
            <div class="addCart_img flex-shrink">
              <van-image
                v-if="detail.goodsImg"
                lazy-load
                :src="`${detail.goodsImg}?imageView2/1/w/150/h/150`"
              />
              <img class="radius5" v-else src="@/assets/images/good/good-none.png" />
            </div>
            <div class="flex flex-auto flex-column justify-between addCart_good_main f13">
              <p class="red f15 fb" v-if="detail.sellFactPrice">
                ¥<span class="f26 lin30">{{ detail.sellFactPrice }}</span>
              </p>
              <p class="gray6 f20" v-else><span>暂无价格</span></p>
              <p class="gray9 f13">
                库存<span class="gray3 pad5-l">{{ detail.currQuantity }}件</span>
              </p>
              <p class="f13 flex" v-if="specification.specType === 1">
                <span class="gray9 flex-shrink">已选</span>
                <span class="text-overflow flex-auto">
                  <span
                    class="pad5-l gray3"
                    v-for="(sku, index) in specification.skuSpecsList"
                    :key="index"
                    >{{ sku }}</span
                  >
                </span>
              </p>
            </div>
          </div>
          <!-- 多规格 -->
          <div class="pad5-t flex-auto overflow-auto" v-if="specification.specType === 1">
            <div v-for="(item, index) in specification.specialList" :key="index">
              <p class="gray6 f14_rem addCart_specification_head">{{ item.specType }}</p>
              <ul class="clear">
                <li
                  v-for="(spec, index1) in item.specValList"
                  :key="index1"
                  :class="{
                    addCart_specification_active: spec === specification.skuSpecsList[index]
                  }"
                  @click="skuClick(spec, index)"
                >
                  {{ spec }}
                </li>
              </ul>
            </div>
          </div>
          <div class="pad5-t" v-else>
            <p class="gray6 f14_rem addCart_specification_head">规格</p>
            <ul class="clear">
              <li class="addCart_specification_active">{{ detail.spec }}</li>
            </ul>
          </div>
          <div class="clear mar30_t mar15_b" v-if="detail.sellFactPrice">
            <span class="float-left gray6 f14_rem">购买数量</span>
            <div class="float-right">
              <van-stepper
                v-model="addCartNum"
                input-width="120px"
                button-size="24px"
                :class="{
                  'minus-disabled':
                    detail.minOrderQuantity &&
                    detail.minOrderQuantity > 1 &&
                    addCartNum <= detail.minOrderQuantity,
                  'plus-disabled': detail.currQuantity >= addCartNum
                }"
                :max="detail.currQuantity"
                :decimal-length="detail.goodsDigit"
                @blur="formatNum"
                @change="stepperChange"
              />
              <div
                class="f10 pad5-t text-center"
                v-if="detail.minOrderQuantity && detail.minOrderQuantity > 0"
              >
                {{ detail.minOrderQuantity }}{{ detail.mUnitCn }}起订
              </div>
            </div>
          </div>
          <div class="addCart_pop_btn">
            <p
              v-if="detail.currQuantity"
              class="b_red bor-red white f16 lin40 radius50"
              @click="addCartPram"
            >
              {{
                detail.sUnitCn && detail.unitRatio
                  ? `加入购物车(共${Number(
                      (Number(addCartNum) * Number(detail.unitRatio)).toFixed(6)
                    )}${detail.sUnitCn})`
                  : "加入购物车"
              }}
            </p>
            <p v-else class="bg-c2c2c2 white f16 lin40 radius50">库存不足</p>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import jsonp from "jsonp";
import { Toast } from "vant";
import { mapState } from "vuex";
import Search from "@/components/search";
import common from "../../assets/js/common";

export default {
  components: {
    Search
  },

  data() {
    return {
      goodLoading: true,
      search: "",
      // 一级分类
      guideList: [],
      guideActive: 0, // 一级分类选中的id
      guideAllShow: 0, // 一级分类是否展开
      guideAllHeight: "0px", // 以及分类展开的高度
      // 二级分类
      classList: [],
      classActive: "",
      // 三级分类
      class2AllList: [],
      class2Active: "",
      class2AllActive: 0,
      class2AllHeight: "0px",
      // 商品
      goodsList: [],
      pageNum: 1,
      pageSize: 10,
      totalPage: 1,
      allGoodLoaing: false,
      allGoodFinished: false,

      afterAxis: "",
      floorId: "",
      customNum: "",

      adList: [],

      countCart: 0,

      // navScroll: 0,
      currentTopNav: {},

      isSlide: false,

      scrollTop: 0,

      specification: {
        specType: 0,
        specialList: [],
        skuSpecsList: []
      },
      addCartNum: 1, // 加入进货车的数量
      detail: {}, // 加入购物车的详情
      addCartShow: false, // 是否显示加购物车选择规则弹框
      source: ""
    };
  },
  computed: mapState({
    userInfo: state => state.app.userInfo
  }),
  created() {
    const { id, sourceFrom } = this.$route.query;
    this.guideActive = Number(id);
    this.isSlide = !!this.guideActive;
    this.source = sourceFrom;
    console.log(id);
    Toast.loading({
      mask: true,
      message: "加载中...",
      duration: 0
    });
  },
  mounted() {
    this.getAdList();
    this.getGideList();
    if (this.userInfo.id) {
      this.getCountCart();
    }
  },

  beforeRouteLeave(to, from, next) {
    this.scrollTop = document.getElementById("goodList").getBoundingClientRect().top;
    next();
  },
  // 进入该页面时，用之前保存的滚动位置赋值
  beforeRouteEnter(to, from, next) {
    next(vm => {
      setTimeout(() => {
        // const { id } = vm.$route.query;
        // const { guideList, guideActive } = vm;
        // console.log("guideList.length", guideList.length);
        // let guideIndex = 0;
        // if (guideList.length) {
        //   guideList.forEach((item, index) => {
        //     if (item.id === guideActive) {
        //       guideIndex = index;
        //     }
        //   });
        //   if (guideIndex !== 0 && !id && document.querySelector("#topNavUl")) {
        //     vm.$nextTick(() => {
        //       console.log(guideActive, guideIndex);
        //       vm.chooseGuide(guideActive, guideIndex, "li");
        //     });
        //   }
        // }

        if (document.getElementById("goodListWrap")) {
          console.log("beforeRouteEnter", vm.scrollTop);
          document.getElementById("goodListWrap").scrollTop = -vm.scrollTop + 261;
        }
      }, 100);
    });
  },
  methods: {
    getAdList() {
      const url = "https://graphicinformation.nxin.com/getJsonFormatAdList/276";
      jsonp(url, (err, res) => {
        console.log(err);
        this.adList = res || [];
      });
    },
    // 获取一级分类
    getGideList() {
      this.$store.dispatch("categories/getCategoryOneList").then(data => {
        this.guideList = data;
        const { isSlide, guideActive } = this;
        let guideIndex = 0;
        if (isSlide) {
          this.guideList.forEach((item, index) => {
            if (item.id === guideActive) {
              guideIndex = index;
            }
          });
          this.$nextTick(() => {
            this.chooseGuide(guideActive, guideIndex, "li");
            this.isSlide = false;
          });
        } else {
          const firstId = data && data.length ? data[0].id : "";
          this.guideActive = firstId;
          this.getClassList(this.guideActive);
        }
      });
    },

    // 获取二级分类
    getClassList(guideId) {
      this.$store
        .dispatch("categories/getCategoryTwoList", {
          id: guideId
        })
        .then(data => {
          const list = data || [];
          this.classList = list.filter(item => item.isShow);
          if (this.classList.length == 0) {
            this.goodsList = [];
            this.totalPage = 0;
            this.allGoodLoaing = true;
            Toast.clear();
            return;
          }
          const { id, afterAxis, floorId, customNum } = this.classList[0];
          this.classActive = id;
          this.afterAxis = afterAxis || "";
          this.floorId = floorId || "";
          this.customNum = customNum || "";
          this.goodsList = [];
          this.goodLoading = true;
          this.allGoodFinished = false;
          this.getGoodList();
        });
    },

    onLoad() {
      const { pageNum, totalPage, goodsList } = this;
      if (pageNum > totalPage || !goodsList.length) {
        return;
      }
      this.pageNum += 1;
      this.allGoodLoaing = true;
      this.getGoodList();
    },
    // 获取商品列表
    getGoodList() {
      const { pageNum, pageSize, afterAxis, floorId, customNum, source } = this;
      this.$store
        .dispatch("categories/getCategoryGoodsList", {
          floorId,
          customNum,
          afterAxis,
          pageNum,
          pageSize,
          source
        })
        .then(res => {
          this.goodLoading = false;
          console.log("商品列表", res);
          const { goodsList, totalPage } = res;
          const list = goodsList || [];
          list.forEach(item => {
            item.price = item.sellFactPriceStr.split(".");
            item.vipMoneyStr = item.vipMoney ? item.vipMoney.toFixed(2) : "";
            const tag = [];
            if (item.isOptimization === 1) {
              tag.push("优选");
            }
            if (item.isPrevent === 1) {
              tag.push("防非");
            }
            if (item.isPrescription === 1) {
              tag.push("处方药");
            }
            if (item.goodsTagList && item.goodsTagList.length > 0) {
              item.goodsTagList.forEach(label => {
                tag.push(label);
              });
            }
            if (item.promotionTypeEng === "GROUP_PURCHASE") {
              tag.push("集采");
            } else if (item.promotionTypeEng === "BUY_GIFTS") {
              tag.push(`买${item.promotionStock}赠${item.giftCount}`);
            } else if (item.promotionTypeEng === "DISCOUNT") {
              tag.push(`${item.promotionRate}折优惠`);
            } else if (item.promotionTypeEng === "DIRECT_SELLING") {
              tag.push(`直降${item.promotionMoney}元`);
            }
            item.tag = tag;
          });
          this.goodsList = [...this.goodsList, ...list];
          this.totalPage = totalPage;
          this.allGoodLoaing = false;
          if (pageNum >= this.totalPage) {
            this.allGoodFinished = true;
          }
        })
        .finally(() => {
          Toast.clear();
        });
    },
    // 查询购物车数量
    getCountCart() {
      this.$store.dispatch("member/member/getCountCart", this.$qs.stringify({})).then(data => {
        const num = data || 0;
        this.countCart = num > 99 ? "99+" : num;
      });
    },
    // 加入购物车
    addCart(goods) {
      // 判断商品品类--商业服务跳转
      if (goods.axisStr && goods.axisStr.indexOf("$4616$") > -1) {
        window.location.href = `${process.env.VUE_APP_WEB_QLW}appmrket/shopjump?t=m&id=${
          goods.goodsId
        }`;
        return;
      }
      if (!common.isLogin(this.userInfo.id)) {
        return;
      }
      this.detail = goods;
      if (goods.minOrderQuantity && goods.minOrderQuantity > 1) {
        this.addCartNum = goods.minOrderQuantity;
      }

      if (goods.specType === 1) {
        const { specType, specialList, skuSpecsIndex } = this.detail;
        const skuSpecsList = skuSpecsIndex.split(" ");
        this.specification = {
          specType,
          specialList,
          skuSpecsList
        };
        this.addCartShow = true;
        return;
      }

      const params = {
        goodsId: goods.goodsId,
        goodsQuantity: 1,
        fromShopId: goods.shopIds
      };
      this.$store.dispatch("goodDetails/goodDetails/addCart", { params }).then(data => {
        if (data.success === true) {
          Toast.success("添加成功");
          this.getCountCart();
        } else if (data.errorcode === -2) {
          window.location.href = `${
            process.env.VUE_APP_APP
          }mob/goods/isShowDisplayPrice.do?goodsId=${goods.goodsId}&url=/mob/shop/shopDetail/${
            goods.shopIds
          }`;
        } else {
          Toast.fail(data.errormsg);
        }
      });
    },

    // 选择切换一级分类
    chooseGuide(id, index, type) {
      // isSlide
      console.log("type", type);
      const { isSlide, guideActive } = this;
      if (guideActive === id && !isSlide) {
        return;
      }
      let destination = index - 2;
      destination = destination < 0 ? 1 : destination;
      if (this.navScroll) {
        this.navScroll.scrollToElement(
          document.querySelector(`#topNav li:nth-child(${destination})`)
        );
      }

      this.guideActive = id;
      this.guideAllShow = 0;
      this.guideAllHeight = "0px";
      Toast.loading({
        mask: true,
        message: "加载中...",
        duration: 0
      });
      this.afterAxis = "";
      this.floorId = "";
      this.customNum = "";
      this.pageNum = 1;
      this.getClassList(id);

      // 横向滑动居中
      const ul = document.querySelector("#topNavUl");
      const nav = document.getElementById("topNav");
      const dom = ul.getElementsByTagName("li")[index];
      console.log("dom", dom);
      const winWidth = window.innerWidth; // 屏幕宽度;
      // const dom = e.target;
      if (dom) {
        let domoffsetWidth = dom.offsetLeft;
        if (type === "all" && index > 4) {
          domoffsetWidth = dom.offsetLeft + winWidth;
        }
        // 中间值 =( 屏幕宽度 - li宽度 ) / 2;
        const diffWidth = (winWidth - dom.offsetWidth) / 2;
        // 目标值 = offset - 中间值
        const targetOffset = -(domoffsetWidth - diffWidth);
        const ulWidth = ul.getBoundingClientRect().width; // 开始

        // 未超出中间值
        if (-targetOffset < 0) {
          nav.scrollLeft = 0;
          return;
        }
        // 末尾
        if (targetOffset < winWidth - ulWidth) {
          nav.scrollLeft = -(winWidth - ulWidth - 30);
          return;
        }
        // 正常
        nav.scrollLeft = -targetOffset;
      }
    },
    // 顶部一级导航显示/隐藏
    guideAllToggle() {
      if (this.guideAllShow) {
        this.guideAllShow = 0;
        this.guideAllHeight = "0px";
      } else {
        this.guideAllShow = 1;
        this.guideAllHeight = "500px";
      }
    },

    // 选择切换二级分类
    chooseClass(item) {
      const { id, afterAxis, floorId, customNum } = item;
      this.classActive = id;
      this.afterAxis = afterAxis || "";
      this.floorId = floorId || "";
      this.customNum = customNum || "";
      this.goodsList = [];
      this.goodLoading = true;
      this.allGoodFinished = false;
      this.pageNum = 1;
      this.getGoodList();
    },

    // 三级级分类显示/隐藏全部分类
    class2AllToggle() {
      if (this.class2AllActive) {
        this.class2AllActive = 0;
        this.class2AllHeight = "0px";
      } else {
        this.class2AllActive = 1;
        this.class2AllHeight = "1000px";
      }
    },

    // 点击跳转
    routerClick(url, type) {
      if (!url) {
        return;
      }
      if (type === "cart") {
        if (!common.isLogin(this.userInfo.id)) {
          return;
        }
        this.$router.push(url);
      } else if (type === "adv") {
        window.location.href = url;
      } else if (type === "sc") {
        window.location.href = `${process.env.VUE_APP_APP}${url}`;
      } else {
        this.$router.push(url);
      }
    },

    // 购物车减号
    stepperChange(value) {
      const { detail } = this;
      if (value && Number(value) < Number(detail.minOrderQuantity)) {
        this.$nextTick(() => {
          this.addCartNum = Number(detail.minOrderQuantity);
        });
      }
    },
    // 多规格值点击
    skuClick(sku, index) {
      const { goodsId } = this.detail;
      this.specification.skuSpecsList[index] = sku;
      const skuSpecsIndex = this.specification.skuSpecsList.join(" ");
      this.$store
        .dispatch("goodDetails/goodDetails/getGoodsSkuId", {
          goodsId,
          skuSpecsIndex
        })
        .then(data => {
          console.info("多规格值点击", data);
          const id = data || goodsId;
          this.getGoodsDetail(id);
        });
    },
    getGoodsDetail(goodsId) {
      this.$store
        .dispatch(
          "goodDetails/goodDetails/detail",
          this.$qs.stringify({
            goodsId
          })
        )
        .then(data => {
          const detail = data.data || {};
          // 商品不存在或已下架
          // if (data.code === "402003" || data.code === "402008") {
          //   const ua = navigator.userAgent.toLowerCase();
          //   if (ua.match(/MicroMessenger/i) == "micromessenger") {//eslint-disable-line
          //     wx.miniProgram.getEnv((res) => {
          //       if (res.miniprogram) {
          //         // 小程序
          //         wx.miniProgram.navigateTo({ url: `${process.env.VUE_APP_APP}mob/goods/toCommodityShelves?goodsId=${this.goodsId}` });
          //       }
          //     });
          //   }
          //   window.location.href = `${process.env.VUE_APP_APP}mob/goods/toCommodityShelves?goodsId=${this.goodsId}`;
          //   return;
          // }
          // 设置多规格
          const { specType, specialList, skuSpecsIndex, imgUrl1, goodsPrice } = detail;
          this.detail = {
            ...detail,
            goodsImg: imgUrl1,
            sellFactPrice: goodsPrice.sellFactPrice || ""
          };
          if (specType === 1) {
            const skuSpecsList = skuSpecsIndex.split(" ");
            this.specification = {
              specType,
              specialList,
              skuSpecsList
            };
          }
        });
    },
    addCartPram() {
      const { detail, addCartNum } = this;
      // 判断商品品类--商业服务跳转
      if (detail.axisStr && detail.axisStr.indexOf("$4616$") > -1) {
        window.location.href = `${process.env.VUE_APP_WEB_QLW}appmrket/shopjump?t=m&id=${
          detail.goodsId
        }`;
        return;
      }
      const params = {
        goodsId: detail.goodsId,
        goodsQuantity: detail.specType === 1 ? addCartNum : 1,
        fromShopId: detail.shopIds
      };
      this.$store.dispatch("goodDetails/goodDetails/addCart", { params }).then(data => {
        this.addCartShow = false;
        if (data.success === true) {
          Toast.success("添加成功");
          this.getCountCart();
        } else if (data.errorcode === -2) {
          window.location.href = `${
            process.env.VUE_APP_APP
          }mob/goods/isShowDisplayPrice.do?goodsId=${detail.goodsId}&url=/mob/shop/shopDetail/${
            detail.shopIds
          }`;
        } else {
          Toast.fail(data.errormsg);
        }
      });
    },
    // num 输入的数字 scale精确小数位数 negative true负数
    formatNum(event) {
      let { value } = event.target;
      const scale = this.detail.goodsDigit;
      value = value.replace(/[^\d.]/g, "");
      value = value.replace(/\.{2,}/g, ".");
      value = value.replace(".", "$#$");
      value = value.replace(/\./g, "");
      value = value.replace("$#$", ".");
      const reg = new RegExp(`^(-)?(\\d{1,8})\\.(\\d{0,${scale}}).*$`);
      value = value.replace(reg, "$1$2.$3");
      value = parseFloat(value);

      if (value && Number(value) < Number(this.detail.minOrderQuantity)) {
        Toast("不可少于最低起订量，请重新输入");
        this.addCartNum = this.detail.minOrderQuantity;
      } else {
        this.addCartNum = value;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./style.scss";
</style>
